export type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
const BASE_URL =
  "https://socialmediabackendhm-ceguagb0bsewd6cz.eastus2-01.azurewebsites.net";
const DOTNET_API_URL =
  "https://socialmediawebappdotnet-c5gvgzgqauekgmej.westindia-01.azurewebsites.net";

export interface ApiRequestOptions<TBody = unknown> {
  method?: HttpMethod;
  body?: TBody;
  headers?: Record<string, string>;
  token?: string;
  apiType?: 1 | 2;
}

export interface ApiResponse<T> {
  data: T;
  status: number;
}

export async function apiClient<TResponse, TBody = unknown>(
  endpoint: string,
  options: ApiRequestOptions<TBody> = {}
): Promise<ApiResponse<TResponse>> {
  const { method = "GET", body, headers = {}, token, apiType } = options;

  const base = apiType === 2 ? DOTNET_API_URL : BASE_URL;

  const fullUrl = base + endpoint;

  const response = await fetch(fullUrl, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const contentType = response.headers.get("content-type");

  let data: any = null;
  if (contentType?.includes("application/json")) {
    data = await response.json();
  } else {
    data = await response.text();
  }

  if (!response.ok) {
    throw {
      status: response.status,
      message: data?.message || "API request failed",
      data,
    };
  }

  return {
    data,
    status: response.status,
  };
}
